import { closeSnackbar, enqueueSnackbar } from 'notistack';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ProgressBar from './ProgressBar';

const enqueueSnackbarClose = (key) => {
  closeSnackbar(key);
};
const commonToast = (message, color, options) => {
  const duration = 3000;
  enqueueSnackbar(message, {
    variant: color || 'success',
    autoHideDuration: duration,
    anchorOrigin: { vertical: 'top', horizontal: 'center' },
    preventDuplicate: true,
    style: { top: '70px' },
    className: 'alert-snackbar',
    action: (key) => (
      <>
        <ProgressBar duration={duration} close={() => enqueueSnackbarClose(key)} />
        <HighlightOffIcon
          onClick={() => enqueueSnackbarClose(key)}
          sx={{ position: 'relative', bottom: '11px', cursor: 'pointer', fontSize: '15px' }}
        />
      </>
    ),
    ...options,
  });
};
export default commonToast;
